import PropTypes from 'prop-types';
import { Typography, FormHelperText } from '@material-ui/core';
import MaterialGrid from '@material-ui/core/Grid';
import {
  AUDIENCE_OPTIONS,
  audienceCheckbox,
  isStationGuestFeatureEnabled,
  isAudienceFeatureApplicable,
  initAudienceFields,
  buildAudienceTypes as buildAudienceTypesHelper,
} from './audienceSection';
import PrimaryButton from 'common/components/buttons/primaryButton';
import SecondaryButton from 'common/components/buttons/secondaryButton';
import GenericConfirmationCard from 'common/components/cards/genericConfirmationModel/genericConfirmationModel';
import { InputLabelOutlined } from 'common/components/fields/InputLabelOutlined';
import { InputSwitchLarge } from 'common/components/fields/InputSwitchLarge';
import { SelectMultiple } from 'common/components/fields/SelectMultiple';
import { SelectLabel } from 'common/components/fields/SelectLabel';
import states from 'helpers/states.json';
import { FORM_RULES } from 'helpers/validations';
import _ from 'lodash';
import { requiredFieldError } from 'modules/owner/pages/actions/actionsFile';
import {
  getContactsByStationIdSetForm,
  getContactsByStationIdLimited,
  getUsersByIds,
  changeUsers,
} from 'modules/owner/pages/contacts/contactsActions';
import React, { Component, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Field,
  Form,
  change,
  getFormMeta,
  getFormSyncErrors,
  getFormValues,
  reduxForm,
} from 'redux-form';
import { getList as getPlansList } from '../../plans/plansActions';
import { getStationActiveActions } from '../activeActions/activeActionsScripts';
import AsyncSelect from 'react-select/async';

class Publish extends Component {
  constructor(props) {
    super(props);
    this.state = {
      states: states,
      submitted: false,
      poppedUp: false,
      callback: null,
      options: [],
      selectedValues: [],
      isAsyncInputDirty: false,
    };

    /*this.props.getStationActiveActions(this.props.auth.user.establishments[0].stations[0].id);
    this.props.getContactsByStationIdSetForm(
      this.props.auth.user.establishments[0].stations[0].id,
      this.props.formValues?.segment_users,
      this.props.form
    );*/
    //buscar aqui os usuarios e e enfiar lá no form asybc select
    this.populateAsyncSelect(this.props.formValues?.segment_users);
    this.props.getPlansList(this.props.auth.user.establishments[0].stations[0].id);
  }

  componentDidMount() {
    initAudienceFields({
      auth: this.props.auth,
      formValues: this.props.formValues,
      changeField: this.props.changeField,
      form: this.props.form,
    });

    const orderedStates = [
      {
        id: 10,
        sigla: 'all',
        nome: 'Todos',
      },
      ...states,
    ];
    orderedStates.sort(function (a, b) {
      if (a.id === 10) {
        return -1;
      }
      if (b.id === 10) {
        return 1;
      }
      if (a.sigla < b.sigla) {
        return -1;
      }
      if (a.sigla > b.sigla) {
        return 1;
      }
      return 0;
    });

    this.setState({ states: orderedStates });
    this.syncOrderingToggles();
  }

  syncOrderingToggles() {
    const { formValues, form, change } = this.props;
    if (!formValues || !change || !form) return;
    const hasNumericPriority =
      formValues.priority != null && formValues.priority !== '' && Number(formValues.priority) > 0;
    if (hasNumericPriority && !formValues.hasPriority) {
      change(form, 'hasPriority', true);
    }
    const hasNumericCarousel =
      formValues.priorityCarousel != null &&
      formValues.priorityCarousel !== '' &&
      Number(formValues.priorityCarousel) > 0;
    if (hasNumericCarousel && !formValues.hasPriorityInCarousel) {
      change(form, 'hasPriorityInCarousel', true);
    }
  }

  componentDidUpdate(props) {
    const prevPriority = props.formValues?.priority;
    const nextPriority = this.props.formValues?.priority;
    const prevCarousel = props.formValues?.priorityCarousel;
    const nextCarousel = this.props.formValues?.priorityCarousel;
    if (prevPriority !== nextPriority || prevCarousel !== nextCarousel) {
      this.syncOrderingToggles();
    }

    if (!_.isEmpty(this.props.submitErrors) && this.state.submitted && !this.state.poppedUp) {
      this.props.requiredFieldError();
      this.setState({ poppedUp: true });
      this.setState({ submitted: false });
    }
    if (this.props.submitErrors !== props.submitErrors && this.state.poppedUp) {
      this.setState({ poppedUp: false });
    }
    if (
      !this.props.contacts.loading &&
      this.props.contacts.list.content &&
      this.props.contacts.list.content.length > 0 &&
      props.contacts.list.content !== this.props.contacts.list.content
    ) {
      if (this.state.callback) {
        this.state.callback(
          this.props.contacts.list.content.map((item) => ({ value: item.id, label: item.email }))
        );
      }
      this.setState({
        options: this.props.contacts.list.content.map((item) => ({
          value: item.id,
          label: item.email,
        })),
      });
    }
    if (
      !this.props.contacts.loading &&
      this.props.contacts.list.defaultValues &&
      this.props.contacts.list.defaultValues.length > 0 &&
      props.contacts.list.defaultValues !== this.props.contacts.list.defaultValues
    ) {
      const value = this.props.contacts.list.defaultValues.map((item) => ({
        value: item.id,
        label: item.email,
      }));
      this.setState({ selectedValues: value });
    }
  }

  buildAudienceTypes = (values) => buildAudienceTypesHelper(this.props.auth, values);

  blockOnInvalidAudience = (values) => {
    if (!isStationGuestFeatureEnabled(this.props.auth)) return false;
    if (!isAudienceFeatureApplicable(values)) return false;
    const types = this.buildAudienceTypes(values) || [];
    if (types.length === 0) {
      this.props.requiredFieldError();
      return true;
    }
    return false;
  };

  onSubmit = (values) => {
    if (this.blockOnInvalidAudience(values)) return;
    if (values.categories_field) {
      values.categories = values.categories_field.map((item) => item.id);
    }
    if (values.groupings_field) {
      values.groupings = values.groupings_field.map((item) => item.id);
    }
    if (values.has_target && this.state.isAsyncInputDirty) {
      values.segment_users = (values.segment_users || [])
        .filter((item) => item !== null && item !== undefined)
        .map((item) => item?.value)
        .filter((v) => v !== null && v !== undefined && v !== '');
    }
    const audienceTypes = this.buildAudienceTypes(values);
    if (audienceTypes) values.audience_types = audienceTypes;
    values.submitFromButton = true;
    this.props.onClickProgress(values);
  };

  onSubmitSec = (values) => {
    if (this.blockOnInvalidAudience(values)) return;
    values.categories = values.categories_field.map((item) => item.id);
    values.groupings = values.groupings_field.map((item) => item.id);
    if (values.has_target) {
      values.segment_users = (values.segment_users || [])
        .filter((item) => item !== null && item !== undefined)
        .map((item) => item?.id)
        .filter((v) => v !== null && v !== undefined && v !== '');
    }
    const audienceTypes = this.buildAudienceTypes(values);
    if (audienceTypes) values.audience_types = audienceTypes;
    values.submitFromButton = true;
    this.props
      .onClickProgress(values)
      .then(() => {
        this.props.closeModal();
      })
      .catch(() => {});
  };

  populateAsyncSelect = (segment_users) => {
    this.props.getUsersByIds(segment_users);
  };

  getSelectContacts = (inputValue, callback) => {
    this.setState({ callback: callback });
    this.props.getContactsByStationIdLimited(
      this.props.auth.user.establishments[0].stations[0].id,
      inputValue
    );
  };

  lazySelect = (field) => {
    const atividade = this?.props?.formValues;
    const now = new Date();
    const isDisabled = !atividade?.is_draft && now > new Date(atividade?.end);

    return (
      <div>
        <AsyncSelect
          cacheOptions
          isMulti
          noOptionsMessage={() => 'Não encontrado'}
          loadingMessage={() => 'Pesquisando...'}
          placeholder={'Pesquise o usuário'}
          defaultOptions
          loadOptions={this.getSelectContacts}
          value={this.state.selectedValues}
          onChange={(value) => {
            this.setState({ selectedValues: value, isAsyncInputDirty: true });
            field.input.onChange(value);
          }}
          isDisabled={isDisabled}
        />
        {field.meta.touched && field.meta.error ? (
          <FormHelperText style={{ color: '#FF5A52' }}>
            {field.meta.touched && field.meta.error}
          </FormHelperText>
        ) : (
          <FormHelperText>Você pode selecionar mais de uma opção</FormHelperText>
        )}
      </div>
    );
  };

  render() {
    const statesList = this.state.states.map((item, index) => ({
      value: item.sigla,
      label: item.nome,
    }));

    const plansList = this.props.plans.list.content.map((item, index) => ({
      value: item.id,
      label: item.name,
    }));

    const ageError = "A idade 'De' está menor que 'Para'";
    const atividade = this?.props?.formValues;
    const now = new Date();
    const isDisabled = !atividade?.is_draft && now > new Date(atividade?.end);
    return (
      <>
        <Form role="form" onSubmit={this.props.handleSubmit(this.onSubmit)} noValidate>
          <div
            style={{
              overflowY: 'scroll',
              height: isMobile ? 'calc(100vh - 250px)' : 'calc(100vh - 355px)',
              overflowX: 'hidden',
              paddingRight: isMobile ? 0 : 15,
            }}>
            <div style={{ marginTop: 20 }}>
              <Typography style={{ fontSize: 16, fontWeight: '400' }} variant="subtitle2">
                Agendamento da publicação
              </Typography>
              <MaterialGrid container spacing={3}>
                <MaterialGrid item xs={12} md={6}>
                  <Field
                    component={InputLabelOutlined}
                    label={'Início'}
                    name="start"
                    type="datetime-local"
                    required
                    validate={[FORM_RULES.required]}
                    margin="normal"
                    disabled={isDisabled}
                    nativePicker={this.props.nativePicker}
                  />
                </MaterialGrid>
                <MaterialGrid item xs={12} sm={12} md={6}>
                  <Field
                    component={InputLabelOutlined}
                    label={'Fim'}
                    name="end"
                    type="datetime-local"
                    required
                    validate={[FORM_RULES.required]}
                    margin="normal"
                    disabled={isDisabled}
                    nativePicker={this.props.nativePicker}
                  />
                </MaterialGrid>
              </MaterialGrid>
            </div>
            <div style={{ marginTop: 20 }}>
              <Typography style={{ fontSize: 16, fontWeight: '400' }} variant="subtitle2">
                Agendamento da participação
              </Typography>
              <MaterialGrid container spacing={3}>
                <MaterialGrid item xs={12} md={6}>
                  <Field
                    component={InputLabelOutlined}
                    label={'Início'}
                    name="participationStart"
                    type="datetime-local"
                    required
                    validate={[FORM_RULES.required]}
                    margin="normal"
                    disabled={isDisabled}
                    nativePicker={this.props.nativePicker}
                  />
                </MaterialGrid>
                <MaterialGrid item xs={12} sm={12} md={6}>
                  <Field
                    component={InputLabelOutlined}
                    label={'Fim'}
                    name="participationEnd"
                    type="datetime-local"
                    required
                    validate={[FORM_RULES.required]}
                    margin="normal"
                    disabled={isDisabled}
                    nativePicker={this.props.nativePicker}
                  />
                </MaterialGrid>
              </MaterialGrid>
            </div>
            {this.props.formValues ? (
              this.props.formValues.is_event ? (
                <MaterialGrid container spacing={3}>
                  <MaterialGrid item xs={12} md={6}>
                    <Field
                      component={InputLabelOutlined}
                      label={'Data de início do evento'}
                      name="event_start"
                      type="datetime-local"
                      disabled={
                        this.props.disabled ||
                        this.props.router.params.action === 'proposta' ||
                        isDisabled
                      }
                      required
                      validate={[FORM_RULES.required]}
                      margin="normal"
                    />
                  </MaterialGrid>
                  <MaterialGrid item xs={12} sm={12} md={6}>
                    <Field
                      component={InputLabelOutlined}
                      label={'Data do fim do evento'}
                      name="event_end"
                      type="datetime-local"
                      disabled={
                        this.props.disabled ||
                        this.props.router.params.action === 'proposta' ||
                        isDisabled
                      }
                      required
                      validate={[FORM_RULES.required]}
                      margin="normal"
                    />
                  </MaterialGrid>
                </MaterialGrid>
              ) : null
            ) : null}

            {this.props.podeSerExclusivaDaJornada === false ? null : (
              <MaterialGrid item xs={12}>
                <Field
                  component={InputSwitchLarge}
                  label={'Exclusiva de jornada'}
                  firstState="Só aparece dentro da jornada"
                  secondState="Aparece normalmente nas categorias"
                  name="journey_only"
                  disabled={isDisabled}
                />
              </MaterialGrid>
            )}

            <MaterialGrid item xs={12}>
              <Field
                component={InputSwitchLarge}
                label={'Ordem'}
                name="hasPriority"
                disabled={isDisabled}
              />
            </MaterialGrid>
            {this.props.formValues ? (
              this.props.formValues.hasPriority || this.props.formValues.priority ? (
                <MaterialGrid item xs={12} sm={12}>
                  <Field
                    component={InputLabelOutlined}
                    label="Número da ordem"
                    helperText="O número da ordem determina a posição desta atividade na categoria.
Ordem 1 aparece em primeiro lugar, 2 em segundo e assim por diante (1 a 1000)."
                    name="priority"
                    type="number"
                    required
                    validate={[
                      FORM_RULES.required,
                      FORM_RULES.number,
                      FORM_RULES.minValue(1),
                      FORM_RULES.maxValue(1000),
                    ]}
                    margin="normal"
                  />
                </MaterialGrid>
              ) : null
            ) : null}

            <MaterialGrid item xs={12}>
              <Field
                component={InputSwitchLarge}
                label={'Ordenar no carossel'}
                name="hasPriorityInCarousel"
                disabled={isDisabled}
              />
            </MaterialGrid>
            {this.props.formValues && this.props.formValues.hasPriorityInCarousel && (
              <MaterialGrid item xs={12} sm={12}>
                <Field
                  component={InputLabelOutlined}
                  label="Número da ordem no carrossel"
                  helperText="O número da ordem determina a posição desta atividade no carrossel em destaque.
Ordem 1 aparece em primeiro lugar, 2 em segundo e assim por diante (1 a 1000)."
                  name="priorityCarousel"
                  type="number"
                  required
                  validate={[
                    FORM_RULES.required,
                    FORM_RULES.number,
                    FORM_RULES.minValue(1),
                    FORM_RULES.maxValue(1000),
                  ]}
                  margin="normal"
                />
              </MaterialGrid>
            )}
            {/** ********************Se vai ou não ter segmentação *********************/}
            <MaterialGrid item xs={12}>
              <Field
                component={InputSwitchLarge}
                label={'Limitar atividade por público alvo'}
                name="has_target"
                disabled={this.props.router.params.action === 'proposta' || isDisabled}
                required
                margin="normal"
              />
            </MaterialGrid>
            {this.props.formValues?.has_target ? (
              <>
                {/** ********************TIPO DE SEGMENTAÇÃO *********************/}
                {(() => {
                  const inlineAudience =
                    isStationGuestFeatureEnabled(this.props.auth) &&
                    isAudienceFeatureApplicable(this.props.formValues) &&
                    this.props.formValues?.segmentation_type === 'public';
                  const leftCol = inlineAudience ? 6 : 12;
                  return (
                    <MaterialGrid container spacing={3}>
                      <MaterialGrid item xs={12} md={leftCol}>
                        <Typography style={{ fontSize: 16, fontWeight: '400' }} variant="subtitle2">
                          Definir público alvo
                        </Typography>
                        <MaterialGrid container spacing={3}>
                          <MaterialGrid item xs={12} sm={12} md={inlineAudience ? 12 : 6}>
                            <Field
                              component={SelectLabel}
                              type="text"
                              label={`Tipo de segmentação`}
                              name={`segmentation_type`}
                              disabled={
                                this.props.router.params.action === 'proposta' || isDisabled
                              }
                              margin="normal"
                              options={[
                                { value: 'public', label: 'Por público' },
                                { value: 'users', label: 'Para usuários específicos' },
                              ]}
                              validate={[FORM_RULES.required]}
                            />
                          </MaterialGrid>
                        </MaterialGrid>
                        {this.props.formValues?.segmentation_type === 'public' ? (
                          <MaterialGrid container spacing={3}>
                            <MaterialGrid item xs={12} sm={12} md={inlineAudience ? 12 : 6}>
                              <MaterialGrid container spacing={3}>
                                <MaterialGrid item xs={12} sm={6} md={6}>
                                  <Field
                                    component={InputLabelOutlined}
                                    label="De (anos)"
                                    name="from"
                                    type="number"
                                    disabled={
                                      this.props.router.params.action === 'proposta' || isDisabled
                                    }
                                    validate={[FORM_RULES.required]}
                                    required
                                    margin="normal"
                                    helperText={
                                      this.props.formValues
                                        ? parseInt(this.props.formValues.from) >
                                          parseInt(this.props.formValues.to)
                                          ? ageError
                                          : null
                                        : null
                                    }
                                  />
                                </MaterialGrid>
                                <MaterialGrid item xs={12} sm={6} md={6}>
                                  <Field
                                    component={InputLabelOutlined}
                                    label="Até (anos)"
                                    name="to"
                                    disabled={
                                      this.props.router.params.action === 'proposta' || isDisabled
                                    }
                                    type="number"
                                    validate={[FORM_RULES.required]}
                                    required
                                    helperText={
                                      this.props.formValues
                                        ? parseInt(this.props.formValues.from) >
                                          parseInt(this.props.formValues.to)
                                          ? ageError
                                          : null
                                        : null
                                    }
                                    margin="normal"
                                  />
                                </MaterialGrid>
                              </MaterialGrid>
                            </MaterialGrid>
                          </MaterialGrid>
                        ) : null}
                      </MaterialGrid>
                      {inlineAudience ? (
                        <MaterialGrid item xs={12} md={6}>
                          <Typography
                            style={{ fontSize: 16, fontWeight: '400' }}
                            variant="subtitle2">
                            Selecione os grupos da atividade
                          </Typography>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              gap: 8,
                              marginTop: 8,
                            }}>
                            {AUDIENCE_OPTIONS.map((opt) => (
                              <Field
                                key={opt.value}
                                name={`audience_${opt.value}`}
                                component={audienceCheckbox(opt, isDisabled)}
                              />
                            ))}
                          </div>
                          {!this.props.formValues?.audience_filiado &&
                          !this.props.formValues?.audience_amigo &&
                          !this.props.formValues?.audience_dependente ? (
                            <FormHelperText style={{ color: '#FF5A52' }}>
                              Selecione pelo menos um público.
                            </FormHelperText>
                          ) : null}
                        </MaterialGrid>
                      ) : null}
                    </MaterialGrid>
                  );
                })()}

                {/** ********************Para usuários específicos *********************/}
                {this.props.formValues ? (
                  this.props.formValues.segmentation_type === 'users' ? (
                    <MaterialGrid container spacing={3}>
                      <MaterialGrid item xs={12} sm={12} md={6}>
                        <Field
                          name="segment_users"
                          component={this.lazySelect}
                          required
                          validate={[FORM_RULES.required]}
                          margin="normal"
                          disabled={isDisabled}
                        />
                      </MaterialGrid>
                    </MaterialGrid>
                  ) : this.props.formValues.segmentation_type === 'public' ? (
                    /** ******************** POR PUBLICO *********************/
                    <>
                      <Typography style={{ fontSize: 16, fontWeight: '400' }} variant="subtitle2">
                        Local de divulgação
                      </Typography>
                      <MaterialGrid container spacing={3}>
                        <MaterialGrid item xs={12} sm={12} md={6}>
                          <Field
                            component={SelectMultiple}
                            label={'Estados que poderão participar'}
                            options={statesList}
                            multiple
                            disabled={this.props.router.params.action === 'proposta' || isDisabled}
                            name="states"
                            required
                            validate={[FORM_RULES.required]}
                            margin="normal"
                          />
                        </MaterialGrid>
                      </MaterialGrid>
                      {plansList.length > 0 ? (
                        <>
                          <Typography
                            style={{ fontSize: 16, fontWeight: '400' }}
                            variant="subtitle2">
                            Segmentar por Plano
                          </Typography>
                          <MaterialGrid container spacing={3}>
                            <MaterialGrid item xs={12} sm={12} md={6}>
                              <Field
                                component={SelectMultiple}
                                label={'Escolha o plano'}
                                options={plansList}
                                multiple
                                name="segment_plans"
                                margin="normal"
                                disabled={isDisabled}
                              />
                            </MaterialGrid>
                          </MaterialGrid>
                        </>
                      ) : null}
                      {this.props.auth.user.establishments?.[0]?.entities?.length > 0 ? (
                        <>
                          <Typography
                            style={{ fontSize: 16, fontWeight: '400' }}
                            variant="subtitle2">
                            Segmentar por Entidade
                          </Typography>
                          <MaterialGrid container spacing={3}>
                            <MaterialGrid item xs={12} sm={12} md={6}>
                              <Field
                                component={SelectMultiple}
                                label={'Escolha uma ou mais'}
                                options={this.props.auth.user.establishments?.[0]?.entities?.map(
                                  (item) => ({
                                    value: item.id,
                                    label: item.name,
                                  })
                                )}
                                multiple
                                disabled={
                                  this.props.router.params.action === 'proposta' || isDisabled
                                }
                                name="entities"
                                margin="normal"
                              />
                            </MaterialGrid>
                          </MaterialGrid>
                        </>
                      ) : null}
                    </>
                  ) : null
                ) : null}
              </>
            ) : null}
            {isStationGuestFeatureEnabled(this.props.auth) &&
            isAudienceFeatureApplicable(this.props.formValues) &&
            !(
              this.props.formValues?.has_target &&
              this.props.formValues?.segmentation_type === 'public'
            ) ? (
              <MaterialGrid item xs={12} style={{ marginTop: 16 }}>
                <Typography style={{ fontSize: 16, fontWeight: '400' }} variant="subtitle2">
                  Selecione os grupos da atividade
                </Typography>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
                  {AUDIENCE_OPTIONS.map((opt) => (
                    <Field
                      key={opt.value}
                      name={`audience_${opt.value}`}
                      component={audienceCheckbox(opt, isDisabled)}
                    />
                  ))}
                </div>
                {!this.props.formValues?.audience_filiado &&
                !this.props.formValues?.audience_amigo &&
                !this.props.formValues?.audience_dependente ? (
                  <FormHelperText style={{ color: '#FF5A52' }}>
                    Selecione pelo menos um público.
                  </FormHelperText>
                ) : null}
              </MaterialGrid>
            ) : null}
            <MaterialGrid item xs={12}>
              <Field
                component={InputSwitchLarge}
                label={'Ocultar da área logada'}
                name="only_public"
                disabled={this.props.router.params.action === 'proposta' || isDisabled}
                required
                margin="normal"
              />
            </MaterialGrid>
            <MaterialGrid item xs={12}>
              <Field
                component={InputSwitchLarge}
                label={'Essa atividade estará em destaque para os participantes?'}
                name="featuredPrivate"
                required
                margin="normal"
                disabled={isDisabled}
              />
            </MaterialGrid>

            <MaterialGrid item xs={12}>
              <Field
                component={InputSwitchLarge}
                label={'Essa atividade estará em destaque para os visitantes?'}
                name="featuredPublic"
                required
                margin="normal"
                disabled={isDisabled}
              />
            </MaterialGrid>
            <MaterialGrid item xs={12}>
              <Field
                component={InputSwitchLarge}
                label={'Habilitar comentários e curtidas na atividade'}
                name="comments_and_likes_enabled"
                required
                margin="normal"
                disabled={isDisabled}
              />
            </MaterialGrid>
            <GenericConfirmationCard
              open={this.props.openConfirmation}
              cancelClose={this.props.handleCancelClose}
              labelLeftButton={'Continuar aqui'}
              labelRightButton={this.props.buttonConfirmationLabel}
              title={'Deseja sair sem publicar?'}
              text={'Ao sair sem publicar, as alterações do último passo não serão salvas.'}
              general={this.props.general}
              maxWidthFixed
              confirmButtonColor={'primary'}
              onClose={this.props.handleCancelClose}
              onClick={this.props.closeModal}
            />
          </div>
          <MaterialGrid
            container
            display="flex"
            justifyContent="space-around"
            alignItems="center"
            style={{
              margin: '25px 0px',
              overflowX: 'hidden',
              paddingRight: isMobile ? 0 : 29,
            }}>
            <SecondaryButton
              type="button"
              color="secondary"
              onClick={this.props.prevClick}
              // progress={parseInt(this.props.general.submitProgress)}
              style={{
                margin: 0,
                width: '48%',
                padding: '10px 20px',
                textTransform: 'none',
              }}>
              Voltar
            </SecondaryButton>
            <PrimaryButton
              type="submit"
              color="primary"
              disabled={this.props.activeActions.buttonLoading || isDisabled}
              progress={parseInt(this.props.general.submitProgress)}
              onClick={() => this.setState({ submitted: true })}
              style={{
                margin: 0,
                width: '48%',
                padding: isMobile ? '12px 20px' : '10px 20px',
                textTransform: 'none',
                fontSize: isMobile ? 12 : undefined,
              }}>
              {this.props.activeActions.buttonLoading ? 'Publicando' : 'Publicar'}
            </PrimaryButton>
          </MaterialGrid>
        </Form>
      </>
    );
  }
}

Publish.propTypes = {
  activeActions: PropTypes.shape({
    buttonLoading: PropTypes.any,
  }),
  auth: PropTypes.shape({
    user: PropTypes.shape({
      establishments: PropTypes.any,
    }),
  }),
  buttonConfirmationLabel: PropTypes.any,
  closeModal: PropTypes.func,
  contacts: PropTypes.shape({
    list: PropTypes.shape({
      content: PropTypes.shape({
        filter: PropTypes.func,
      }),
      defaultValues: PropTypes.array,
    }),
  }),
  disabled: PropTypes.any,
  form: PropTypes.any,
  formValues: PropTypes.shape({
    from: PropTypes.any,
    hasPriority: PropTypes.any,
    has_target: PropTypes.any,
    is_event: PropTypes.any,
    segment_users: PropTypes.any,
    segmentation_type: PropTypes.string,
    to: PropTypes.any,
  }),
  general: PropTypes.shape({
    submitProgress: PropTypes.any,
  }),
  getContactsByStationIdSetForm: PropTypes.func,
  getContactsByStationIdLimited: PropTypes.func,
  changeUsers: PropTypes.func,
  getUsersByIds: PropTypes.func,
  getPlansList: PropTypes.func,
  getStationActiveActions: PropTypes.func,
  handleCancelClose: PropTypes.any,
  handleSubmit: PropTypes.func,
  onClickProgress: PropTypes.func,
  openConfirmation: PropTypes.any,
  plans: PropTypes.shape({
    list: PropTypes.shape({
      content: PropTypes.shape({
        map: PropTypes.func,
      }),
    }),
  }),
  prevClick: PropTypes.any,
  requiredFieldError: PropTypes.func,
  router: PropTypes.shape({
    params: PropTypes.shape({
      action: PropTypes.string,
    }),
  }),
  submitErrors: PropTypes.any,
};

const mapStateToProps = (state, { form }) => {
  return {
    auth: state.auth,
    activeActions: state.activeActions,
    formValues: getFormValues(form)(state),
    form: form,
    general: state.general,
    contacts: state.contacts,
    submitErrors: getFormSyncErrors(form)(state),
    metaForm: getFormMeta(form)(state),
    plans: state.plans,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getStationActiveActions,
      getContactsByStationIdSetForm,
      getContactsByStationIdLimited,
      changeUsers,
      getUsersByIds,
      requiredFieldError,
      getPlansList,
      change,
      changeField: change,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  })(Publish)
);
